import { NextPage } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { loadTranslations } from 'src/common/utils/serverSidePropsHelpers';
import Header from '../../src/common/components/Header';
import Layout from '../../src/common/components/Layout';
import DescriptionMetaTag from '../../src/common/components/MetaTags/DescriptionMetaTag';
import { AuthUserApiResponse } from '../../src/common/types/api/v4/auth/user';
import serverGetUser from '../../src/common/utils/serverGetUser';
import handleApiErrors from '../../src/common/utils/handleApiErrors';
import AccessibilityStatement from '../../src/content/Legal/AccessibilityStatement';
import withCommonMiddleware from '../../src/common/utils/withCommonMiddleware';

type AccessibilityStatementPageProps = {
  user: Partial<AuthUserApiResponse>;
};

const AccessibilityStatementPage: NextPage = () => {
  const [t] = useTranslation('legal-accessibility-statement');

  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <DescriptionMetaTag
        content={t('meta-description')}
      />
      <Layout>
        <Header />
        <AccessibilityStatement />
      </Layout>
    </>
  );
};

export const getServerSideProps = (
  handleApiErrors(
    withCommonMiddleware<AccessibilityStatementPageProps>(
      async (context) => {
        const userPromise = serverGetUser(context);
        const translationPromise = loadTranslations(
          context.locale,
          [
            'common',
            'legal-accessibility-statement',
            'navbar',
            'destination-navigation',
          ],
        );

        return {
          props: {
            user: await userPromise,
            ...await translationPromise,
          },
        };
      },
    ),
  )
);

export default AccessibilityStatementPage;
